import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType, act } from "@ngrx/effects";
import {
    fetchMessages,
    fetchMessagesSuccess,
    fetchMessagesFailure,
    getMessage,
    getMessageSuccess,
    getMessageFailure,
    deleteMessage,
    deleteMessageSuccess,
    deleteMessageFailure,
    addMessage,
    addMessageSuccess,
    addMessageFailure
} from "./message.actions";
import { of } from "rxjs";
import { map, mergeMap, catchError, tap } from "rxjs/operators";
import { MessageService, PageService } from '@services/index';

@Injectable()
export class MessagesEffects {

  loadMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchMessages),
      mergeMap(action =>
        this.messageService.getMessages(action.page, action.filterOptions, action.userId).pipe(
          map(res => {
            return fetchMessagesSuccess({ messages: res });
          }),
          catchError(error => {
            return of(fetchMessagesFailure({ error }));
          })
        )
      )
    )
  );

  getMessage$ = createEffect(() =>
  this.actions$.pipe(
    ofType(getMessage),
    mergeMap(action => 
      this.messageService.getMessage(action.id).pipe(
        map(res => {
          return getMessageSuccess({ message: res });
        }),
        catchError(error => {
          return of(getMessageFailure({ error }));
        })
      )
    )
  )
);

  deleteMessage$ = createEffect(() =>
  this.actions$.pipe(
    ofType(deleteMessage),
    mergeMap(action =>
      this.messageService.removeMessage(action.id, action.to).pipe(
        map(() => {
          return deleteMessageSuccess({ id: action.id, to: action.to });
        }),
        tap(res => {     
          this.messageService.fetchMessages(1, {}, res.to );
        }),
        catchError(error => {
          return of(deleteMessageFailure({ error }));
        })
      )
    )
  )
);

  addMessage$ = createEffect(() =>
  this.actions$.pipe(
    ofType(addMessage),
    mergeMap(action =>
      this.messageService.insertMessage(action.message, action.from).pipe(
        map(() => {
          return addMessageSuccess({ message: action.message, from: action.from });
        }),
        tap(res => { 
          this.pageService.onNotificationToggle({ show: true, error: false, message: 'Message Sended Successfully!' });
          this.messageService.fetchMessages(1, {}, res.from );
        }),
        catchError(error => {
          this.pageService.onNotificationToggle({ show: true, error: true, message: 'Something Went Wrong!' });
          return of(addMessageFailure({ error }));
        })
      )
    )
  )
  );

  constructor(
    private actions$: Actions,
    private messageService: MessageService,
    private pageService: PageService
  ) {}
}
